export default "__VITE_ASSET__Dn5SCXTA__"